export enum NotificationDisplayType {
  Now = 'Now',
  AfterNextNavigation = 'AfterNextNavigation',
  AfterExternalRedirect = 'AfterExternalRedirect',
}
